import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { prefetchContributionsPageDataFromApi, useContributionsPageDataFromApi } from './pageData';

export type ContributionsPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useContributionsPageDataFromApi>[0];
}>;

export type ContributionsPageCombinedState = ReturnType<typeof useContributionsPageDataFromApi>;

export function usePageContext(prefetchedData?: ContributionsPagePrefetchedContext): ContributionsPageCombinedState {
	return useContributionsPageDataFromApi(prefetchedData?.pageData);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<ContributionsPagePrefetchedContext> {
	const pageData = await prefetchContributionsPageDataFromApi(context);

	return { pageData };
}

export type ContributionsPagePrefetchedDataProps = PrefetchedDataProps<ContributionsPagePrefetchedContext>;
